import React, { useEffect } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { RegistrationForm } from './components/RegistrationForm';
import { WhatYouLearn } from './components/WhatYouLearn';
import { WhoItsFor } from './components/WhoItsFor';
import { Instructor } from './components/Instructor';
import { Urgency } from './components/Urgency';
import { Footer } from './components/Footer';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="w-full min-h-screen bg-navy font-inter" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <RegistrationForm data-id="element-3" />
      <WhatYouLearn data-id="element-4" />
      <WhoItsFor data-id="element-5" />
      <Instructor data-id="element-6" />
      <Urgency data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}